import { Box } from '@mantine/core'
import { type SearchParameters } from 'algoliasearch-helper'
import React, { useEffect, useMemo } from 'react'
import { Configure, useInstantSearch } from 'react-instantsearch'
import { BasePageLayout } from './BaseLayout'

export const ExpertsPageLayout = ({
  searchParameters,
  setResults,
}: {
  searchParameters: SearchParameters
  setResults?: (results: number | undefined) => void
}) => {
  const { results } = useInstantSearch()
  const memoizedParams = useMemo(
    () => searchParameters,
    [JSON.stringify(searchParameters)]
  )

  useEffect(() => {
    setResults?.(results?.nbHits)
  }, [results?.nbHits, setResults])

  return (
    <Box>
      <Configure {...memoizedParams} />
      <BasePageLayout />
    </Box>
  )
}
